import router from './router'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isHttp } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/register', '/cas/login', '/cas/index', '/auth/mainPlatform/loginFromWX', '/onlinePreviewFile','/ext/login'];

/**获取传递的参数 */
function getUrlParam (url) {
  var object = {};
  if (url.indexOf("?") !== -1) {
    var str = url.split("?")[1];
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      object[strs[i].split("=")[0]] = strs[i].split("=")[1]
    }
    return object
  }
  return object[url];
}

/**拉取user_info信息 */
function handleUserInfo (to, next) {
  if (useUserStore().roles.length === 0) {
    isRelogin.show = true
    // 判断当前用户是否已拉取完user_info信息
    useUserStore().getInfo().then(() => {
      isRelogin.show = false
      usePermissionStore().generateRoutes().then(accessRoutes => {
        // 根据roles权限生成可访问的路由表
        accessRoutes.forEach(route => {
          if (!isHttp(route.path)) {
            router.addRoute(route) // 动态添加可访问路由表
          }
        })
        if (to.path.includes('/auth/loginFromCenter')) {
          console.log(to, '789-1');
          const { callBackUrl } = to.query;
          if (callBackUrl) {
            console.log(to, '789-2');
            if (callBackUrl.indexOf('http') == 0) {
              location.replace(callBackUrl);
            } else {
              next({ path: callBackUrl });
            }
          } else {
            console.log(to, '789-3');
            next({ path: '/' })
          }
        } else {
          console.log(to, '789-4');
          try {
            const callBackUrl = to.redirectedFrom?.query?.callBackUrl;
            if (callBackUrl) {
              console.log(to, '789-5');
              if (callBackUrl.indexOf('http') == 0) {
                console.log(to, '789-6');
                location.replace(callBackUrl);
              } else {
                console.log(to, '789-7');
                next({ path: callBackUrl });
              }
            } else {
              console.log(to, '789-8');
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            }
          } catch (e) {
            console.log(to, '789-9', e);
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          }
        }
      })
    }).catch(err => {
      useUserStore().logOut().then(() => {
        // next({ path: '/' })
        location.reload();
      })
    })
  } else {
    next()
  }
}



if (location.host.indexOf('whrhkj') > -1) {
  document.title = '仁和会计企业管理平台';
  // Main平台域名：
    router.beforeEach((to, from, next) => {
      if (!['/cas/login', '/auth/mainPlatform/loginFromWX', '/cas/index'].includes(to.path)) {
        next({ path: '/cas/login' }) // 非main平台的3个页面全部重定向到main登录页
      } else {
        next()
      }
    })
} else {
  // 若衣域名：
  router.beforeEach((to, from, next) => {
    NProgress.start()
    document.title = '仁和CRM';
    if (getToken()) {
      //判断是否是模拟登录
      if (to.path.includes('/auth/loginFromCenter')) {
        console.log(to, '123-1')
        useUserStore().logOut().then(() => {
          const { workNo, uinxTime, sign } = to.query
          useUserStore().loginFromCenter({ workNo, uinxTime, sign }).then(res => {
            console.log(to, '123-2')
            handleUserInfo(to, next)
          }).catch((err) => {
            console.log(err, to, '123-3')
            next({ path: '/' })
          })
        })
      } else {
        to.meta.title && useSettingsStore().setTitle(to.meta.title)
        /* has token*/
        if (to.path === '/login') {
          next({ path: '/' })
          NProgress.done()
        } else {
          handleUserInfo(to, next)
        }
      }
    } else {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        if (to.path === "/login") {
          if (to.query?.redirect?.includes('/auth/loginFromCenter')) {
            console.log(to, '456-1')
            const { workNo, uinxTime, sign } = getUrlParam(to.query.redirect)
            useUserStore().loginFromCenter({ workNo, uinxTime, sign }).then(res => {
              console.log(to, '456-2')
              handleUserInfo(to, next)
            }).catch((err) => {
              console.log(to, '456-3')
              next()
              NProgress.done()
            })
          } else {
            next()
            NProgress.done()
          }
        } else {
          next()
          NProgress.done()
        }
      } else {
        next({ path: '/login', query: { redirect: to.fullPath } }) // 否则全部重定向到登录页
      }
    }
  })
}


router.afterEach((to, from, next) => {
  if (to.path.match(/^\/qwTools/)) {
    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />');
  } else {
    $('head').find('meta[name=viewport]').remove();
  }

  NProgress.done()
})
